export const Link = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 10H9C5.68629 10 3 12.6863 3 16V16C3 19.3137 5.68629 22 9 22H13M19 10H23C26.3137 10 29 12.6863 29 16V16C29 19.3137 26.3137 22 23 22H19" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
<path d="M11 16H21" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
</svg>`;
